import { Howl } from 'howler'
import store from '@/store'

const Musics = {
	elements: [],
	playing: null,
	will_playing: null,
	// volume: 0.3 / 1.5,

	init() {
		let start = Date.now()
		let loaded = []
		const files = require.context('@/assets/musics/', true, /^.*\.ogg$/).keys()
		for (let id in files) {
			let slug = files[id].substr(2).replace('.ogg', '')
			const url = require('@/assets/musics/' + files[id].substr(2))
			let volume = 0.5
			if (slug === 'main') volume = 0.25
			this.elements.push({
				slug,
				howl: new Howl({
					src: [ url ],
					volume,
					loop: true,
					onload: () => {
						loaded.push(url)
						if (loaded.length === files.length) store.commit('SET_LOADED', { musics: true })
					}
				})
			})
		}
		console.info(this.elements.length + ' musics loaded in ' + (Date.now() - start) + 'ms')
	},

	play(slug, fade = 1000) {
		// if (this.volume) {
			const music = this.elements.find(e => e.slug === slug)
			if (music) {
				if (this.playing) {
					if (this.playing.slug !== slug && (!this.will_playing || this.will_playing.slug !== slug)) {
						// this.playing.howl.fade(this.volume, 0, fade)
						this.will_playing = music
						setTimeout(() => {
							this.playing.howl.stop()
							// console.log('♫♫♫ STOP (' + this.playing.slug + ') ♫♫♫')
							music.howl.volume(this.volume)
							music.howl.play()
							// console.log('♫♫♫ PLAY (' + music.slug + ') ♫♫♫')
							this.playing = music
							this.will_playing = null
						}, fade)
					}
				} else {
					music.howl.play()
					console.log('♫♫♫ PLAY (' + music.slug + ') ♫♫♫')
					this.playing = music
					this.will_playing = null
				}
			}
		// }
	},

	stop() {
		if (this.playing && this.playing.howl) {
			console.log('♫♫♫ STOP (' + this.playing.slug + ') ♫♫♫')
			this.playing.howl.stop()
			this.playing = null
			this.will_playing = null
		}
	},

	set_volume(volume) {
		// this.volume = volume / 1.5
		// this.elements.forEach((element) => {
		// 	element.howl.volume(volume / 1.5)
		// })
	}

}



export default Musics